export default "Calorifugeage de points singuliers (vannes, brides, échangeurs) en chaufferie et locaux techniques (fiche CEE BAT-TH-146). Quick win prioritaire du plan -40 % OPERAT.";
